import React, {useEffect, useState} from 'react';
import { getDecimal } from "../config/utils";
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';
import {useSxStyles as sx} from "../styles/sxStyles";

const SelectedFees = (props) => {
    const fees = props.fees;
    const feeTotal = props.feeTotal;
    const processingFee = props.processingFee;
    const removeSelected = props.removeSelected;
    const selectedOption = props.selectedOption;
    const [totalAmount, setTotalAmount] = useState(0);

    useEffect(() => {
        let total = 0;
        if (feeTotal) total += feeTotal;
        if (processingFee) total += processingFee;
        total = parseFloat(getDecimal(total, false));
        setTotalAmount(total);
    }, [feeTotal, processingFee])

    return (<>
        <Typography variant='h6' component='h3' color='primary' sx={{fontSize: '1.2rem', marginTop: 1, marginBottom: '.5rem'}}>Selected Fees</Typography>
        <Paper elevation={3} sx={{...sx.tableContainer, padding: '1rem'}}>
            <List sx={sx.list} >
                <ListItem alignItems="flex-start" sx={sx.listPadding}>
                    <ListItemText
                        sx={sx.listText}
                        primary={
                            <Grid2
                                container
                                spacing={1}
                                style={{width: '100%'}}
                            >
                                <Grid2
                                    size={{
                                        xs: 6,
                                        md: 4
                                    }}>Fee Name</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 6,
                                        md: 2
                                    }}>Item Amt.</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 5,
                                        md: 2
                                    }}>Qty.</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 6,
                                        md: 3
                                    }}>Amount</Grid2>
                                <Grid2 size={1}>&nbsp;</Grid2>
                            </Grid2>
                        }
                        slotProps={{
                            primary: {
                                component: 'span',
                                variant: 'subtitle1',
                                sx:sx.inline,
                                color: 'primary'
                            }
                        }}
                    />
                </ListItem>
                {fees && fees.map((fee) => {
                    return (<>
                        <ListItem alignItems="flex-start" divider sx={sx.listPadding}>
                            <ListItemText
                                sx={sx.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={1}
                                        style={{width: '100%'}}
                                    >
                                        <Grid2
                                            size={{
                                                xs: 6,
                                                md: 4
                                            }}>{fee.name}</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 6,
                                                md: 2
                                            }}>{getDecimal(fee.itemAmount)}</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 5,
                                                md: 2
                                            }}>{getDecimal(fee.quantity)}</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 6,
                                                md: 3
                                            }}>{getDecimal(fee.amount)}</Grid2>
                                        <Grid2 sx={sx.valueRight} size={1}>
                                            <DeleteForeverTwoToneIcon onClick={() => removeSelected(fee.key)} />
                                        </Grid2>
                                    </Grid2>
                                }
                                secondary={
                                    fee.comments ?
                                    <Grid2
                                        container
                                        style={{width: '100%'}}
                                    >
                                        <Grid2 size={3}><Typography variant='subtitle2' color='secondary'>Comments:</Typography> </Grid2>
                                        <Grid2 size={9}><Typography variant='body2' color='textPrimary'>{fee.comments}</Typography></Grid2>
                                    </Grid2> : null
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx:sx.inline,
                                        color: 'textPrimary'
                                    }
                                }}
                            />
                        </ListItem>
                    </>);
                })}
                { selectedOption &&
                    <ListItem alignItems="flex-start" divider sx={sx.listPadding}>
                        <ListItemText
                            sx={sx.listText}
                            primary={
                                <Grid2
                                    container
                                    spacing={1}
                                    style={{width: '100%'}}
                                >
                                    <Grid2
                                        size={{
                                            xs: 6,
                                            md: 4
                                        }}>{selectedOption.name}</Grid2>
                                    <Grid2
                                        size={{
                                            xs: 6,
                                            md: 4
                                        }}>Description: {selectedOption.description}</Grid2>
                                    <Grid2
                                        sx={sx.valueRight}
                                        size={{
                                            xs: 6,
                                            md: 3
                                        }}>{getDecimal(selectedOption.amount)}</Grid2>
                                    <Grid2 size={1}>&nbsp;</Grid2>
                                </Grid2>
                            }
                            slotProps={{
                                primary: {
                                    component: 'span',
                                    variant: 'body2',
                                    sx:sx.inline,
                                    color: 'textPrimary'
                                }
                            }}
                        />
                    </ListItem>
                }
                <ListItem alignItems="flex-start" sx={sx.listPadding}>
                    <ListItemText
                        sx={sx.listText}
                        primary={
                            <Grid2
                                container
                                spacing={1}
                                style={{width: '100%'}}
                            >
                                <Grid2
                                    size={{
                                        xs: 4,
                                        md: 2
                                    }}>&nbsp;</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 8,
                                        md: 3
                                    }}>Fee Total:</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 5,
                                        md: 3
                                    }}>Processing Fee:</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 6,
                                        md: 3
                                    }}>Payment Total:</Grid2>
                                <Grid2 size={1}>&nbsp;</Grid2>
                                <Grid2
                                    size={{
                                        xs: 4,
                                        md: 2
                                    }}>&nbsp;</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 8,
                                        md: 3
                                    }}>{getDecimal(feeTotal)}</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 5,
                                        md: 3
                                    }}>{getDecimal(processingFee)}</Grid2>
                                <Grid2
                                    sx={sx.valueRight}
                                    size={{
                                        xs: 6,
                                        md: 3
                                    }}>{getDecimal(totalAmount)}</Grid2>
                                <Grid2 size={1}>&nbsp;</Grid2>
                            </Grid2>
                        }
                    />
                </ListItem>
            </List>
        </Paper>
    </>);
}

export default SelectedFees;
